import React from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function RoleSkeleton() {
    return (
        <>
            {[1, 2, 3 , 4].map((index) => {
                return (
                    <div className="oneRole card-hover" >
                        <div className='imgSkeleton' >
                            <Skeleton height='100%' borderRadius={500} />
                        </div>
                        <br></br>
                        <div style={{width: '50%'}}>
                            <Skeleton  />
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export default RoleSkeleton;